
"use client";
import React, { useState, useEffect, Suspense, useRef } from "react";
import { NavMenu } from "./NavMenu";
import { Link } from 'react-router-dom';
import Url from '../../src/Url';
// import "./trailnavbar.css";
import { useNavigate } from 'react-router-dom';

export const NavBar = () => {
  const [transparentNav, setTransparentNav] = useState(true);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const myRef = useRef(null);
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);
  const [displayMobileNav, setDisplayMobileNav] = useState(false);
  const [activeMobileIndex, setActiveMobileIndex] = useState(null);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1000);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY >= 70) {
        setTransparentNav(false);

      } else {
        setTransparentNav(true);
      }
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);



  const navListArray = [
    {
      name: "Solutions", subItems: [{ name: "Facility Management Software", path: "/solutions/facilities-management-software" },
      { name: "Handyman Software", path: "/solutions/handyman-management-software" },
      { name: "Cleaning Management Software", path: "/solutions/cleaning-management-software" },
      { name: "Truck booking Software", path: "/" },
      { name: "Telemedicine Software", path: "/" },
      { name: "Hospital Management Software", path: "/" },
      { name: "E-Commerce Solution", path: "/" },
      { name: "M-Commerce Solution", path: "/" },
      { name: "Event Transportation Software", path: "/" },
      { name: "Aircrew Transit Software", path: "/" },
      { name: "Employee Transportation Software", path: "/" },
      { name: "Corporate Carpooling Software", path: "/" },
      { name: "NEMT Software", path: "/" },
      { name: "Taxi Aggregator Software", path: "/" },
      { name: "Bike Taxi Aggregator Software", path: "/" },
      { name: "Fleet Management Software", path: "/" },
      { name: "Last-Mile Delivery Software", path: "/" },
      { name: "Freight Bidding Software", path: "/" },
      { name: "Group Transportation Software", path: "/" },
      { name: "Shuttle & Bus Management Software", path: "/" },
      { name: "Ride Sharing Software", path: "/" },
      { name: "Vehicle Leasing Software", path: "/" },
      { name: "EV Transportation Solutions", path: "/" },
      { name: "Educational Transportation Solutions", path: "/" }

      ]
    },

    {
      name: "Services", subItems: [
        { name: "AI & ML Ecosystem", path: "/" },
        { name: "IoT Ecosystem", path: "/services/iot-development-services/" },
        { name: "Digital Transformation", path: "/" },
        { name: "Digital Twin", path: "/" },
        { name: "Cyber Resilience", path: "/" },
        { name: "Cybersecurity Management", path: "/" },
        { name: "Discovery, Prototyping & MVP", path: "/" },
        { name: "Custom Mobile App Development", path: "/" },
        { name: "IT Consulting", path: "/" },
        { name: "Website Audit", path: "/" },
        { name: "SEO Services", path: "/" },
        { name: "UI/UX Designing", path: "/" },
        { name: "Website Development", path: "/" },
        { name: "QA Testing", path: "/" },
        { name: "App Enhancement & Integration", path: "/" },
        { name: "Staffing Services", path: "/" },
        { name: "DevOps Services", path: "/" },
        { name: "IT Maintenance & Support", path: "/" },
        { name: "Digital Commerce", path: "/" },
        { name: "Product Development", path: "/" },
        { name: "Custom Software Development", path: "/" },
        { name: "Cloud Services", path: "/" },
        { name: "Robotic Process Automation", path: "/" },
        { name: "Shopify Growth Consulting", path: "/" }]
    },
    {
      name: "Industry", subItems: [
        { name: "Healthcare", path: "/" },
        { name: "Finance & Banking", path: "/" },
        { name: "Retail & E-Commerce", path: "/" },
        { name: "Manufacturing", path: "/" },
        { name: "Transportation & Logistics", path: "/" },
        { name: "Energy & Utilities", path: "/" },
        { name: "Telecommunications", path: "/" },
        { name: "Education", path: "/" },
        { name: "Legal & Compliance", path: "/" },
        { name: "Media & Entertainment", path: "/" },
        { name: "Startups", path: "/" },
        { name: "Real Estate", path: "/" },
        { name: "Automotive", path: "/" },
        { name: "Agriculture", path: "/" },
        { name: "Public Sector & Government", path: "/" },
        { name: "Insurance", path: "/" },
        { name: "Hospitality & Tourism", path: "/" },
        { name: "Oil & Gas", path: "/" },
        { name: "Pharmaceuticals", path: "/" },
        { name: "Food & Beverage", path: "/" },
        { name: "Fashion & Apparel", path: "/" },
        { name: "Construction  & Engineering", path: "/" },
        { name: "Aerospace & Defence", path: "/" },
        { name: "Chemicals", path: "/" },
        { name: "Luxury Goods", path: "/" },
        { name: "Human Resources", path: "/" },
        { name: "Mining & Natural Resources", path: "/" },
        { name: "Nonprofit & NGOs", path: "/" },
        { name: "Consumer Electronics", path: "/" },
        { name: "Petrochemicals", path: "/" },
        { name: "Publishing & Printing", path: "/" },
        { name: "Logistics & Supply Chain", path: "/" }]
    },

    // { name: "Work", path: "/work/" },
    { name:<span style={{ cursor: "pointer" }}>Work</span>, path: "/work/" },
    {
      name: "Company", subItems: [
        { name: "About", path: "/about-us/" },
        { name: "Partners", path: "/company/partners" },
        { name: "Media", path: "/" },
        { name: "CSR", path: "/" },
        {
          name: (
            <> The tr<span style={{ color: "#3681f4", fontWeight: "bold" }}>AI</span>lique Way</>), path: "/"
        },
        { name: "Technology Stack", path: "/technology-stack" },
        { name: "Newsroom", path: "/" },
        { name: "Blogs", path: "/blog" },
        { name: "Careers", path: "/career" }]
    },
  ];

  const handleNavClick = (path) => {
    if (path) {
      if (window.location.pathname === path) {
        window.location.reload(); // Force page reload if already on the same page
      } else {
        navigate(path);
      }
    }
  };

  const toggleMobileDropdown = (index) => {
    setActiveMobileIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  

  return (
    <>
      <Suspense fallback={<div>Loading...</div>}>

        {!isMobile ? (
          <div ref={myRef} className={`trailnavbar ${transparentNav ? "transparent" : ""} ${!transparentNav ? "trailsolid" : ""}`}>
            <div className="logo">
              {transparentNav ? (
                <a href="/">
                  <img
                    src={`${Url.imageUrl}opt/buildrightdark.webp`}
                    width={120}

                    height={60}
                    alt="Logo Transparent"
                  /></a>
              ) : (
                <a href="/">
                  <img
                    src={`${Url.imageUrl}opt/logoopt.png`}
                    width={120}
                    height={60}
                    alt="Logo Solid"
                  /></a>
              )}
            </div>
            <nav className="nav-list-el">
              <ul>
                {navListArray.map((navEle, index) => (
                  <li
                    key={index}
                    className={transparentNav ? "transparent-item" : "trailsolid-item"}
                    onClick={() => handleNavClick(navEle.path)}
                    onMouseEnter={() => setHoveredIndex(index)}
                    onMouseLeave={() => setHoveredIndex(null)}
                  >
                    {navEle.name}
                  </li>
                ))}
                <li className="nav-button">
                  <a href="/contact-us" className="btns btns-primary">
                    Contact us
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        ) : (
          <div className="mobile-trailnavbar">
            <Link to="/">
              <div className="mobile-logo">
                <img
                  src={`${Url.imageUrl}opt/buildright.webp`}
                  width={120}
                  height={150}
                  alt="Logo"
                  style={{ margin: "15px" }}
                  loading="lazy"
                />
              </div>
            </Link>
            <div className="hamburger-menu">
              <a href="/contact-us">
                <img
                  src={`${Url.imageUrl}opt/phone-call.png`}
                  height={40}
                  width={40}
                  alt="phone-call"
                  style={{ margin: "15px" }}
                  loading="lazy"
                />
              </a>
              <img
                src={`${Url.imageUrl}opt/bars.png`}
                height={40}
                width={40}
                alt="hamburger"
                style={{ margin: "15px" }}
                onClick={() => setDisplayMobileNav((prev) => !prev)}
              />
              {displayMobileNav && (
                <nav className="mobile-nav-list">
                  <ul>
                  {navListArray.map((navEle, index) => (
  <li key={index}>
    <div
      className="mobile-nav-item"
      onClick={() => {
        toggleMobileDropdown(index);
        handleNavClick(navEle.path);
        if (navEle.subItems && activeMobileIndex !== index) {
          setTimeout(() => {
            document.getElementById(`submenu-${index}`)?.focus();
          }, 100); // Delay to ensure the submenu is rendered
        }
      }}
    >
      {navEle.name}
      {navEle.subItems && (
        <span className="dropdown-arrow">
          {activeMobileIndex === index ? (
            <img src={`${Url.imageUrl}opt/drop-up.png`} width={25} height={25} alt="Active Dropup Arrow" />
          ) : (
            <img src={`${Url.imageUrl}opt/drop-down.png`} width={25} height={25} alt="Active Dropdown Arrow" />
          )}
        </span>
      )}
    </div>

    {navEle.subItems && activeMobileIndex === index && (
      <ul
        id={`submenu-${index}`}
        className="mobile-submenu"
        tabIndex={-1} // Make it focusable
      >
        {navEle.subItems.map((subItem, subIndex) => (
          <li
            key={subIndex}
            className="mobile-sub-item"
            onClick={() => handleNavClick(subItem.path)}
          >
            {subItem.name}
          </li>
        ))}
      </ul>
    )}
  </li>
))}


                    <li className="mobile-nav-button">
                      <a href="/contact-us" className="btns btns-primary">
                        Contact us
                      </a>
                    </li>
                  </ul>
                  <div className="navbar-contact-section">
                    <p> Call us</p>
                    <h4> +1 (408) 493-2090 <br />
                      +91 8177 844 080</h4>
                    <p>Write to us</p>
                    <h4>info@trailique.ai</h4>
                    <p>Careers</p>
                    <h4>careers@trailique.ai</h4>
                  </div>
                </nav>
              )}
            </div>
          </div>
        )}

        {hoveredIndex !== null && (
          <div
            onMouseEnter={() => setHoveredIndex(hoveredIndex)}
            onMouseLeave={() => setHoveredIndex(null)}
            className="mega-menu"
          >
            <NavMenu
              index={hoveredIndex}
              onMouseEnter={() => setHoveredIndex(hoveredIndex)}
              onMouseLeave={() => setHoveredIndex(null)}
            />
          </div>
        )}
      </Suspense>

    </>
  );
};












// "use client";
// import React, { useState, useEffect, Suspense, useRef } from "react";
// import { NavMenu } from "./NavMenu";
// import { Link } from 'react-router-dom';
// import Url from '../../src/Url';
// // import "./trailnavbar.css";
// import { useNavigate } from 'react-router-dom';

// export const NavBar = () => {
//   const [transparentNav, setTransparentNav] = useState(true);
//   const [hoveredIndex, setHoveredIndex] = useState(null);
//   const myRef = useRef(null);
//   const navigate = useNavigate();
//   const [isMobile, setIsMobile] = useState(false);
//   const [displayMobileNav, setDisplayMobileNav] = useState(false);
//   const [activeMobileIndex, setActiveMobileIndex] = useState(null);

//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth <= 1000);
//     };

//     handleResize();
//     window.addEventListener("resize", handleResize);
//     return () => {
//       window.removeEventListener("resize", handleResize);
//     };
//   }, []);

//   useEffect(() => {
//     const handleScroll = () => {
//       if (window.scrollY >= 70) {
//         setTransparentNav(false);

//       } else {
//         setTransparentNav(true);
//       }
//     };

//     handleScroll();
//     window.addEventListener("scroll", handleScroll);

//     return () => {
//       window.removeEventListener("scroll", handleScroll);
//     };
//   }, []);



//   const navListArray = [
//     {
//       name: "Solutions", subItems: [{ name: "Facility Management Software", path: "/solutions/facilities-management-software/" },
//       { name: "Handyman Software", path: "/solutions/handyman-management-software/" },
//       { name: "Cleaning Management Software", path: "/solutions/cleaning-management-software/" },
//       { name: "Last-Mile Delivery Software", path: "/" },
//       { name: "Property Rental Software", path: "/" },
//       { name: "Event Transportation Software", path: "/" },
//       { name: "Telemedicine Software", path: "/telemedicine" },
//       { name: "Hospital Management Software", path: "/hospital" },
//       { name: "E-Commerce Solution", path: "#" },
//       { name: "M-Commerce Solution", path: "/" },

//       { name: "Employee Transportation Software", path: "/" },
//       { name: "Corporate Carpooling Software", path: "/" },
//       { name: "NEMT Software", path: "/" },
//       { name: "Taxi Aggregator Software", path: "/" },
//       { name: "Aircrew Transit Software", path: "/" },
//       { name: "Bike Taxi Aggregator Software", path: "/" },
//       { name: "Fleet Management Software", path: "/" },
//       { name: "Truck booking Software", path: "/trucking" },

//       { name: "Freight Bidding Software", path: "/" },
//       { name: "Group Transportation Software", path: "/" },
//       { name: "Ride Sharing Software", path: "/" },
//       { name: "Shuttle & Bus Management Software", path: "/" },
//       { name: "Vehicle Leasing Software", path: "/" },
//       { name: "EV Transportation Solutions", path: "/" }
//       ]
//     },

//     {
//       name: "Services", subItems: [
//         { name: "AI & ML Ecosystem", path: "/" },
//         { name: "IoT Ecosystem", path: "/services/iot-development-services/" },
//         { name: "Digital Transformation", path: "/" },
//         { name: "Digital Twin", path: "/" },
//         { name: "Cyber Resilience", path: "/" },
//         { name: "Cybersecurity Management", path: "/" },
//         { name: "Discovery, Prototyping & MVP", path: "/" },
//         { name: "Custom Mobile App Development", path: "/" },
//         { name: "IT Consulting", path: "/" },
//         { name: "Website Audit", path: "/" },
//         { name: "SEO Services", path: "/" },
//         { name: "UI/UX Designing", path: "/" },
//         { name: "Website Development", path: "/" },
//         { name: "QA Testing", path: "/" },
//         { name: "App Enhancement & Integration", path: "/" },
//         { name: "Staffing Services", path: "/" },
//         { name: "DevOps Services", path: "/" },
//         { name: "IT Maintenance & Support", path: "/" },
//         { name: "Digital Commerce", path: "/" },
//         { name: "Product Development", path: "/" },
//         { name: "Custom Software Development", path: "/" },
//         { name: "Cloud Services", path: "/" },
//         { name: "Robotic Process Automation", path: "/" },
//         { name: "Shopify Growth Consulting", path: "/" }]
//     },
//     {
//       name: "Industry", subItems: [
//         { name: "Healthcare", path: "/" },
//         { name: "Finance & Banking", path: "/" },
//         { name: "Retail & E-Commerce", path: "/" },
//         { name: "Manufacturing", path: "/" },
//         { name: "Transportation & Logistics", path: "/" },
//         { name: "Energy & Utilities", path: "/" },
//         { name: "Telecommunications", path: "/" },
//         { name: "Education", path: "/" },
//         { name: "Legal & Compliance", path: "/" },
//         { name: "Media & Entertainment", path: "/" },
//         { name: "Startups", path: "/" },
//         { name: "Real Estate", path: "/" },
//         { name: "Automotive", path: "/" },
//         { name: "Agriculture", path: "/" },
//         { name: "Public Sector & Government", path: "/" },
//         { name: "Insurance", path: "/" },
//         { name: "Hospitality & Tourism", path: "/" },
//         { name: "Oil & Gas", path: "/" },
//         { name: "Pharmaceuticals", path: "/" },
//         { name: "Food & Beverage", path: "/" },
//         { name: "Fashion & Apparel", path: "/" },
//         { name: "Construction  & Engineering", path: "/" },
//         { name: "Aerospace & Defence", path: "/" },
//         { name: "Chemicals", path: "/" },
//         { name: "Luxury Goods", path: "/" },
//         { name: "Human Resources", path: "/" },
//         { name: "Mining & Natural Resources", path: "/" },
//         { name: "Nonprofit & NGOs", path: "/" },
//         { name: "Consumer Electronics", path: "/" },
//         { name: "Petrochemicals", path: "/" },
//         { name: "Publishing & Printing", path: "/" },
//         { name: "Logistics & Supply Chain", path: "/" }]
//     },

//     // { name: "Work", path: "/work/" },
//     { name:<span style={{ cursor: "pointer" }}>Work</span>, path: "/work/" },
//     {
//       name: "Company", subItems: [
//         { name: "About", path: "/about-us/" },
//         { name: "Our Work", path: "/" },
//         { name: "Partners", path: "/company/partners" },
//         { name: "Media", path: "/" },
//         { name: "CSR", path: "/" },
//         {
//           name: (
//             <> The tr<span style={{ color: "#3681f4", fontWeight: "bold" }}>AI</span>lique Way</>), path: "/"
//         },
//         { name: "Technology Stack", path: "/technology-stack" },
//         { name: "Newsroom", path: "/" },
//         { name: "Blogs", path: "/blog" },
//         { name: "Careers", path: "/career" }]
//     },
//   ];

//   const handleNavClick = (path) => {
//     if (path) {
//       navigate(path);
//     }
//   };

//   const toggleMobileDropdown = (index) => {
//     setActiveMobileIndex((prevIndex) => (prevIndex === index ? null : index));
//   };

//   return (
//     <>
//       <Suspense fallback={<div>Loading...</div>}>

//         {!isMobile ? (
//           <div ref={myRef} className={`trailnavbar ${transparentNav ? "transparent" : ""} ${!transparentNav ? "trailsolid" : ""}`}>
//             <div className="logo">
//               {transparentNav ? (
//                 <a href="/">
//                   <img
//                     src={`${Url.imageUrl}opt/buildrightdark.webp`}
//                     width={120}

//                     height={60}
//                     alt="Logo Transparent"
//                   /></a>
//               ) : (
//                 <a href="/">
//                   <img
//                     src={`${Url.imageUrl}opt/logoopt.png`}
//                     width={120}
//                     height={60}
//                     alt="Logo Solid"
//                   /></a>
//               )}
//             </div>
//             <nav className="nav-list-el">
//               <ul>
//                 {navListArray.map((navEle, index) => (
//                   <li
//                     key={index}
//                     className={transparentNav ? "transparent-item" : "trailsolid-item"}
//                     onClick={() => handleNavClick(navEle.path)}
//                     onMouseEnter={() => setHoveredIndex(index)}
//                     onMouseLeave={() => setHoveredIndex(null)}
//                   >
//                     {navEle.name}
//                   </li>
//                 ))}
//                 <li className="nav-button">
//                   <a href="/contact-us" className="btns btns-primary">
//                     Contact us
//                   </a>
//                 </li>
//               </ul>
//             </nav>
//           </div>
//         ) : (
//           <div className="mobile-trailnavbar">
//             <Link to="/">
//               <div className="mobile-logo">
//                 <img
//                   src={`${Url.imageUrl}opt/buildright.webp`}
//                   width={120}
//                   height={150}
//                   alt="Logo"
//                   style={{ margin: "15px" }}
//                 />
//               </div>
//             </Link>
//             <div className="hamburger-menu">
//               <a href="/contact-us">
//                 <img
//                   src={`${Url.imageUrl}opt/phone-call.png`}
//                   height={40}
//                   width={40}
//                   alt="phone-call"
//                   style={{ margin: "15px" }}
//                 />
//               </a>
//               <img
//                 src={`${Url.imageUrl}opt/bars.png`}
//                 height={40}
//                 width={40}
//                 alt="hamburger"
//                 style={{ margin: "15px" }}
//                 onClick={() => setDisplayMobileNav((prev) => !prev)}
//               />
//               {displayMobileNav && (
//                 <nav className="mobile-nav-list">
//                   <ul>
//                     {navListArray.map((navEle, index) => (
//                       <li key={index}>
//                         <div
//                           className="mobile-nav-item"
//                           onClick={() => {
//                             toggleMobileDropdown(index);
//                             handleNavClick(navEle.path);
//                           }}
//                         >
//                           {navEle.name}
//                           {navEle.subItems && (
//                             <span className="dropdown-arrow">
//                               {activeMobileIndex === index ? (
//                                 <img src={`${Url.imageUrl}opt/drop-up.png`} width={25} height={25} alt="Active Dropup Arrow" />
//                               ) : (
//                                 <img src={`${Url.imageUrl}opt/drop-down.png`} width={25} height={25} alt="Active Dropdown Arrow" />
//                               )}
//                             </span>
//                           )}
//                         </div>

//                         {navEle.subItems && activeMobileIndex === index && (
//                           <ul className="mobile-submenu">
//                             {navEle.subItems.map((subItem, subIndex) => (
//                               <li
//                                 key={subIndex}
//                                 className="mobile-sub-item"
//                                 onClick={() => handleNavClick(subItem.path)} // Navigate on subitem click
//                               >
//                                 {subItem.name}
//                               </li>
//                             ))}
//                           </ul>
//                         )}
//                       </li>
//                     ))}

//                     <li className="mobile-nav-button">
//                       <a href="/contact-us" className="btns btns-primary">
//                         Contact us
//                       </a>
//                     </li>
//                   </ul>
//                   <div className="navbar-contact-section">
//                     <p> Call us</p>
//                     <h4> +1 (408) 493-2090 <br />
//                       +91 8177 844 080</h4>
//                     <p>Write to us</p>
//                     <h4>info@trailique.ai</h4>
//                     <p>Careers</p>
//                     <h4>careers@trailique.ai</h4>
//                   </div>
//                 </nav>
//               )}
//             </div>
//           </div>
//         )}

//         {hoveredIndex !== null && (
//           <div
//             onMouseEnter={() => setHoveredIndex(hoveredIndex)}
//             onMouseLeave={() => setHoveredIndex(null)}
//             className="mega-menu"
//           >
//             <NavMenu
//               index={hoveredIndex}
//               onMouseEnter={() => setHoveredIndex(hoveredIndex)}
//               onMouseLeave={() => setHoveredIndex(null)}
//             />
//           </div>
//         )}
//       </Suspense>

//     </>
//   );
// };
